import React from 'react';
import '../../styles/components/common/DateRangePicker.css';

interface DateRangePickerProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  startLabel?: string;
  endLabel?: string;
  startInputClassName?: string;
  endInputClassName?: string;
  startError?: string;
  endError?: string;
  isSingleDate?: boolean;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  startLabel = 'From',
  endLabel = 'To',
  startInputClassName = '',
  endInputClassName = '',
  startError,
  endError,
  isSingleDate = false
}) => {
  return (
    <div className={`date-picker-container ${isSingleDate ? 'single-date' : 'date-range'}`}>
      <div className="date-field">
        <div className="label-with-error">
          <label>{startLabel}</label>
          {startError && <span className="inline-error">{startError}</span>}
        </div>
        <input
          type="date"
          value={startDate}
          onChange={(e) => onStartDateChange(e.target.value)}
          className={`date-input ${startInputClassName}`}
        />
      </div>
      
      {!isSingleDate && (
        <div className="date-field">
          <div className="label-with-error">
            <label>{endLabel}</label>
            {endError && <span className="inline-error">{endError}</span>}
          </div>
          <input
            type="date"
            value={endDate}
            onChange={(e) => onEndDateChange(e.target.value)}
            className={`date-input ${endInputClassName}`}
          />
        </div>
      )}
    </div>
  );
};

export default DateRangePicker; 